import api from './api';

export const getMaterials = async () => {
  const { data } = await api.get('/materials');
  return data;
};

export const createMaterial = async (name) => {
  const { data } = await api.post('/materials', { name });
  return data;
};

export const updateMaterial = async (id, params) => {
  const { data } = await api.put(`/materials/${id}`, params);
  return data;
};

export const deleteMaterial = async (id) => {
  const { data } = await api.delete(`/materials/${id}`);
  return data;
};

export const updateMaterialMappings = async (id, mappings) => {
  const { data } = await api.put(`/materials/${id}/mappings`, { mappings });
  return data;
};
